import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IVisit, IVisitSchedule, IEmailVisitAppointment, ICalendarVisitAppointment } from "src/app/models/patientvisitcalculator/patientvisitcalculator";
import { ITimeZone } from "src/app/models/tools/tools";
import { HttpResponse } from '@microsoft/signalr';
import { CalendarEventFilter } from '../models/community/calendarEventFilter';
import { PortalService } from './portal.service';
import { RoutingService } from './routing.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { CalendarEventTimeZone } from '../models/timezone';
import { CalendarEventCategory } from '../models/community/calendarEventCategory';
import { ICalendarEvents } from '../models/community/calendarEvents';
import { AssignmentRequest } from '../models/community/assignmentRequest';
import { AssignmentResponse, TreeView } from '../models/community/assignmentResponse';
import { CalendarEvent, CalendarEventDelete, CalendarEventEmail } from '../models/community/calendarEvent';
import { UserCalendarPermissions } from '../models/community/userCalendarPermissions';

@Injectable({ providedIn: 'root' })
export class CalendarService {
  private CALENDAR_SERVICE_URL = environment.calendarService.url + environment.calendarService.apiVersion;
  constructor(private http: HttpClient) {
  }

  getAllEnabledVisitSchedules(sponsor: string, portalid: number) {
    return new Promise<IVisitSchedule[]>((resolve, reject) => {
      lastValueFrom(this.http.get(this.CALENDAR_SERVICE_URL + "VisitSchedule/" + sponsor + "/" + portalid + "/Enabled", {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  getAllVisits(sponsor: string, visitScheduleId: number) {
    return new Promise<IVisit[]>((resolve, reject) => {
      lastValueFrom(this.http.get(this.CALENDAR_SERVICE_URL + "VisitSchedule/" + sponsor + "/" + visitScheduleId + "/Visit", {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  addVisitEMailInvite(sponsor: string, portalId: number, emailVisitAppointment: IEmailVisitAppointment) {
    let emailBody = JSON.stringify(emailVisitAppointment);
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post(this.CALENDAR_SERVICE_URL + "VisitSchedule/" + sponsor + "/" + portalId + "/" + emailVisitAppointment.VisitScheduleId + "/Invite", emailBody))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  addVisitToUserCalendar(sponsor: string, portalId: number, calendarVisitAppointment: ICalendarVisitAppointment) {
    let emailBody = JSON.stringify(calendarVisitAppointment);
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post(this.CALENDAR_SERVICE_URL + "VisitSchedule/" + sponsor + "/" + portalId + "/" + calendarVisitAppointment.VisitScheduleId + "/AddCalendar", emailBody))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }  

  havePatientVisitCategory(sponsor: string, portalId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.CALENDAR_SERVICE_URL + "CalendarEventCategory/" + sponsor + "/" + portalId + "/HavePatientVisitCategory", {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  
  getCalendarEventTimeZone() {
    return new Promise<ITimeZone[]>((resolve, reject) => {
      lastValueFrom(this.http.get(this.CALENDAR_SERVICE_URL + "CalendarEventTimeZone", {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  updateTimeZone(timeZoneId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.put(this.CALENDAR_SERVICE_URL + "CalendarEventUserProfile/" + timeZoneId, {}))
        .then(
          (response?: any) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  getCalendarEvents(sponsor: string, portalid: number,calendarEventFilter : CalendarEventFilter ){
    return new Promise<ICalendarEvents>((resolve, reject) => {
       lastValueFrom(this.http.post<ICalendarEvents>(this.CALENDAR_SERVICE_URL + "CalendarEvent/" + sponsor + "/" + portalid, calendarEventFilter 
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getCalendarEventManageableCategories(sponsor: string, portalid: number){
    return new Promise<CalendarEventCategory[]>((resolve, reject) => {
       lastValueFrom(this.http.get(this.CALENDAR_SERVICE_URL + "CalendarEventCategory/Manageable/" + sponsor + "/" + portalid 
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getCalendarEventViewableCategories(sponsor: string, portalid: number){
    return new Promise<CalendarEventCategory[]>((resolve, reject) => {
       lastValueFrom(this.http.get(this.CALENDAR_SERVICE_URL + "CalendarEventCategory/Viewable/" + sponsor + "/" + portalid 
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getCalendarEventFilteringConsole(sponsor: string, portalid: number, assignmentRequest: AssignmentRequest){
    return new Promise<AssignmentResponse>((resolve, reject) => {
       lastValueFrom(this.http.post(this.CALENDAR_SERVICE_URL + "CalendarEvent/FilteringConsole/" + sponsor + "/" + portalid,
          assignmentRequest 
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getFilteringConsoleChilds(sponsor: string, categoryId: number, treeview: TreeView){
    return new Promise<TreeView[]>((resolve, reject) => {
       lastValueFrom(this.http.post(this.CALENDAR_SERVICE_URL + "CalendarEvent/LoadChild/" + sponsor + "/" + categoryId,
       treeview 
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  addCalendarEvent(sponsor: string, portalId: number, calendarEvent: CalendarEvent): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.CALENDAR_SERVICE_URL + "CalendarEvent/Add/" + sponsor + "/" + portalId , calendarEvent)
        ).then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  updateCalendarEvent(sponsor: string, portalId: number, calendarEvent: CalendarEvent): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      firstValueFrom(this.http.put<any>(this.CALENDAR_SERVICE_URL + "CalendarEvent/Update/" + sponsor + "/" + portalId , calendarEvent)
        ).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  deleteCalendarEvent(sponsor: string, portalId: number, calendarEventDetele: CalendarEventDelete): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      firstValueFrom(this.http.request<any>('delete', this.CALENDAR_SERVICE_URL + "CalendarEvent/Delete/" + sponsor + "/" + portalId,{body:calendarEventDetele})
        ).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getCalendarEventById(sponsor: string, portalId: number,calendarEventId:number ){
    return new Promise<CalendarEvent>((resolve, reject) => {
       lastValueFrom(this.http.get<CalendarEvent>(this.CALENDAR_SERVICE_URL + "CalendarEvent/" + sponsor + "/" + portalId + "/" + calendarEventId 
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getUserCalendarPermission(sponsor: string, portalId: number){
    return new Promise<UserCalendarPermissions>((resolve, reject) => {
       lastValueFrom(this.http.get<UserCalendarPermissions>(this.CALENDAR_SERVICE_URL + "CalendarEvent/UserPermission/" + sponsor + "/" + portalId  
        ))
        .then(
          (response?:any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getCalendarEventCategoryById(sponsor: string, portalId: number, calendarEventCategoryId:number){
    return new Promise<CalendarEventCategory>((resolve, reject) => {
      lastValueFrom(this.http.get<CalendarEventCategory>(this.CALENDAR_SERVICE_URL + "CalendarEventCategory/" + sponsor + "/" + portalId  +"/" + calendarEventCategoryId 
       ))
       .then(
         (response?:any) => {
           resolve(response);
         },
         err => {
           reject(err);
         }
       );
   });
  }
  sendCalendarEventEmail(sponsor: string, portalId: number, calendarEventEmail: CalendarEventEmail): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.CALENDAR_SERVICE_URL + "CalendarEvent/Send/" + sponsor + "/" + portalId , calendarEventEmail)
        ).then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
}
